import axios from 'axios';
import { addresses, authorization, baseUrl } from './api-config';

const noTokenOptions = {
  // baseURL: baseUrl.localhostHTTPS,
  baseURL: baseUrl.apiExameCovid,
  headers: authorization.headers
};

export const api = { 
  http: axios.create(noTokenOptions),
  addresses: addresses
}

export const ResultProcess = {
  status: undefined,
  value: []
}